import { render } from "./AboutS11.vue?vue&type=template&id=df559612&scoped=true"
import script from "./AboutS11.vue?vue&type=script&lang=js"
export * from "./AboutS11.vue?vue&type=script&lang=js"

import "./AboutS11.vue?vue&type=style&index=0&id=df559612&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df559612"]])

export default __exports__